<template>
  <div id="app">
    <v-main v-if="$store.state.loaded">
      <router-view />
    </v-main>
    <v-main v-else>
      <div class="text-center">
        <v-progress-circular
          style="margin-top: 15rem!important"
          :size="150"
          :width="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-main>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.embed-container iframe {
    position: absolute !important;
    top:0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
}
#app {
  font-family: "Poiret One", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue